import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReviewDetailsComponent } from '../review-details/review-details.component';
import { ModalService } from 'src/app/services/modal.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { getLeaguePlayers } from 'src/app/store/selectors/tournament.selector';

@Component({
  selector: 'app-create-league-player',
  templateUrl: './create-league-player.component.html',
  styleUrls: ['./create-league-player.component.scss']
})
export class CreateLeaguePlayerComponent implements OnInit {

  form: FormGroup;

  getLeaguePlayers$: Observable<any>;
  league: any;

  ngUnsubscribe = new Subject<void>()

  constructor(
    private fb: FormBuilder,
    private modalService: ModalService,
    private store: Store<AppState>
  ) {
    this.getLeaguePlayers$ = this.store.select(getLeaguePlayers);
   }

  ngOnInit(): void {
    this.getLeaguePlayers$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if(res){
        this.league = res?.league
        console.log(this.league);
      }
    })
    this.form = this.fb.group({
      username: ['', Validators.required],
      playerName: ['', Validators.required]
    });
  }

  // createNewPlayer(){
  //   const payload = {
  //     username: this.username?.value,
  //     playerName: this.playerName?.value,
  //   }
  // }

  confirm() {
    const payload = {
      username: this.username?.value,
      playerName: this.playerName?.value,
      leagueId: this.league?.leagueId
    };

    console.log({payload})

    this.modalService.openReviewDetails(payload, 'create-league-player', this.league ? this.league : {});
    // if (this.form.valid) {
    //   const modalRef = this.modalService.open(ReviewDetailsComponent, { centered: true });
    //   modalRef.componentInstance.reviewData = this.form.value; 
    //   this.close()
    //   modalRef.result.then((result) => {
    //     if (result === 'submit') {
    //       this.createNewPlayer();
    //     }
    //   });
    // } 
  }

  createNewPlayer() {
    const payload = {
      username: this.username?.value,
      playerName: this.playerName?.value,
    };

    console.log(payload)
  }

  get username(){
    return this.form.get('username');
  }

  get playerName(){
    return this.form.get('playerName');
  }

  close(){
    this.modalService.hideCreateLeaguePlayer();
  }
}
